
import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserwayService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  private script: HTMLScriptElement | null = null;
  private readonly storageKey = 'mc-trips-userway-enabled';

  userwayEnabled = false;

  initialize(): void {
    this.userwayEnabled = this.isUserwayEnabled();
    if (this.userwayEnabled) {
      this.embedUserwayScript();
    }
  }

  isUserwayEnabled(): boolean {
    const value = this.document.defaultView?.localStorage?.getItem(this.storageKey);
    // Preserve current app behavior for users without a saved preference.
    return value !== 'false';
  }

  setUserwayEnabled(enabled: boolean): void {
    this.document.defaultView?.localStorage?.setItem(this.storageKey, String(enabled));
    this.userwayEnabled = enabled;
  }

  embedUserwayScript(): void {
    if (this.script) {
      return;
    }

    const script = this.document.createElement('script');
    script.setAttribute('data-position', '3');
    script.setAttribute('data-color', '#55C1AC');
    script.setAttribute('data-account', 'w6OV6uoh4T');
    script.setAttribute('src', 'https://cdn.userway.org/widget.js');
    (this.document.body || this.document.head).appendChild(script);
    this.script = script;
    this.setUserwayEnabled(true);
  }

  removeUserwayScript(): void {
    if (this.script) {
      this.script.remove();
      this.script = null;
    }
    this.setUserwayEnabled(false);
  }
}
